module.exports = __webpack_public_path__ + "img/open.b051ecb4.svg";